import z from 'zod';
import { DocumentMetaTs, ImageTs, LocaleTs } from "../../common";
import { SingleTypes } from '@/providers/strapi';
import { ContentContext } from '../../content-provider';
import { useContext } from 'react';
import { OmitDocumentMeta } from '@/providers/strapi/client/types';
import { SatisfactionCardSchema, TravelerCardSchema } from '../components/retailer.component';
import { ContactUsCardSchema, HowItWorksSchema, ShippingTargetCardSchema, ShipppingPricingSectionSchema, WhyZapptaxCardSchema } from '../components/shipping.component';




export type ShippingPage = z.output<typeof ShippingPageTs>;
export const ShippingPageTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  tagLine: z.string(),
  content: z.string(),
  cta: z.string(),
  satisfactionCard: SatisfactionCardSchema,
  travelerCard: TravelerCardSchema,
  whyZapptaxCard: WhyZapptaxCardSchema,
  shippingTargetCard: ShippingTargetCardSchema,
  howItWorks: HowItWorksSchema,
  pricingSection: ShipppingPricingSectionSchema,
  readInKorean: z.string(),
  heroPicture: ImageTs,
  contactUsCard: ContactUsCardSchema,
  localizations: z.array(DocumentMetaTs)
})

export const SHIPPING = "shipping";
export function useShippingPage<
  K extends keyof Omit<ShippingPage, "id" | "locale" | "localizations" | OmitDocumentMeta>
>(
  entity: K,
  // contextKey: string
): ShippingPage[K] {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`ShippingPage content not found`)
  const ShippingPage = content[SHIPPING] as ShippingPage;
  if (!ShippingPage || !ShippingPage[entity]) throw new Error(`${entity} content not found`)
  return ShippingPage[entity]
}


// type HomePageContentMap = {
//   retailer: RetailerHomePage;
//   traveler: ShippingPage;
// };

// type ValidPageKey = keyof HomePageContentMap;

// type FilteredKeys<T> = keyof Omit<T, "id" | "locale" | "localizations" | OmitDocumentMeta>;

// export function useContent<
//   PageKey extends ValidPageKey,
//   T extends HomePageContentMap[PageKey],
//   K extends FilteredKeys<T>
// >(
//   pageKey: PageKey,
//   entity: K
// ): T[K] {
//   const content = useContext(ContentContext);

//   if (!content) {
//     throw new Error(`${String(pageKey)} content not found`);
//   }

//   const homePage = content[pageKey] as T;

//   const value = homePage?.[entity];
//   if (value === undefined) {
//     throw new Error(`${String(entity)} content not found in ${String(pageKey)}`);
//   }

//   return value;
// }
